export const ERROR_CODE_REQUIRED = 4001
export const ERROR_CODE_REQUIRED_DESCRIPTION = 'Required field'

export const ERROR_CODE_EXACT_LENGTH = 4101
export const ERROR_CODE_EXACT_LENGTH_DESCRIPTION = 'Must equal length'

export const ERROR_CODE_MAX_LENGTH = 4102
export const ERROR_CODE_MAX_LENGTH_DESCRIPTION = 'Above maximum length'

export const ERROR_CODE_MIN_LENGTH = 4103
export const ERROR_CODE_MIN_LENGTH_DESCRIPTION = 'Below minimum length'

export const ERROR_CODE_CONSTANT_MISMATCH = 4201
export const ERROR_CODE_CONSTANT_MISMATCH_DESCRIPTION = 'Must equal'

export const ERROR_CODE_BEGINS_WITH = 4301
export const ERROR_CODE_BEGINS_WITH_DESCRIPTION = 'Must begin with'

export const ERROR_CODE_ENDS_WITH = 4302
export const ERROR_CODE_ENDS_WITH_DESCRIPTION = 'Must end with'

export const ERROR_CODE_MUST_CONTAIN = 4303
export const ERROR_CODE_MUST_CONTAIN_DESCRIPTION = 'Must contain'

export const ERROR_CODE_MUST_NOT_CONTAIN = 4304
export const ERROR_CODE_MUST_NOT_CONTAIN_DESCRIPTION = 'Must not contain'

export const ERROR_CODE_PROHIBIT_LETTERS = 4305
export const ERROR_CODE_PROHIBIT_LETTERS_DESCRIPTION = 'Invalid character: letter'

export const ERROR_CODE_PROHIBIT_NUMBERS = 4306
export const ERROR_CODE_PROHIBIT_NUMBERS_DESCRIPTION = 'Invalid character: number'

export const ERROR_CODE_PROHIBIT_WHITESPACE = 4307
export const ERROR_CODE_PROHIBIT_WHITESPACE_DESCRIPTION = 'Invalid character: whitespace'

export const ERROR_CODE_PROHIBIT_SYMBOLS = 4308
export const ERROR_CODE_PROHIBIT_SYMBOLS_DESCRIPTION = 'Invalid character: symbol'

export const ERROR_CODE_INVALID_DATE = 4401
export const ERROR_CODE_INVALID_DATE_DESCRIPTION = 'Invalid date'

export const ERROR_CODE_INVALID_URL = 4501
export const ERROR_CODE_INVALID_URL_DESCRIPTION = 'Invalid link'

export const ERROR_CODE_INVALID_URL_DOMAIN = 4502
export const ERROR_CODE_INVALID_URL_DOMAIN_DESCRIPTION = 'Invalid domain'

export const ERROR_CODE_INVALID_LIST_VALUE = 4601
export const ERROR_CODE_INVALID_LIST_VALUE_DESCRIPTION = 'Invalid list value'

export const ERROR_CODE_MISSING_LIST_GOVERNANCE = 4602
export const ERROR_CODE_MISSING_LIST_GOVERNANCE_DESCRIPTION = 'Missing list governance'

export const ERROR_CODE_MISSING_LIST = 4603
export const ERROR_CODE_MISSING_LIST_DESCRIPTION = 'Missing list'

export const WARNING_CODE_FLAG_NEW = 7001
export const WARNING_CODE_FLAG_NEW_DESCRIPTION = 'Previously unsubmitted value'

export const cellValidationErrors = {
  [ERROR_CODE_REQUIRED]: ERROR_CODE_REQUIRED_DESCRIPTION,
  [ERROR_CODE_MIN_LENGTH]: ERROR_CODE_MIN_LENGTH_DESCRIPTION,
  [ERROR_CODE_MAX_LENGTH]: ERROR_CODE_MAX_LENGTH_DESCRIPTION,
  [ERROR_CODE_EXACT_LENGTH]: ERROR_CODE_EXACT_LENGTH_DESCRIPTION,
  [ERROR_CODE_CONSTANT_MISMATCH]: ERROR_CODE_CONSTANT_MISMATCH_DESCRIPTION,
  [ERROR_CODE_BEGINS_WITH]: ERROR_CODE_BEGINS_WITH_DESCRIPTION,
  [ERROR_CODE_ENDS_WITH]: ERROR_CODE_ENDS_WITH_DESCRIPTION,
  [ERROR_CODE_MUST_CONTAIN]: ERROR_CODE_MUST_CONTAIN_DESCRIPTION,
  [ERROR_CODE_MUST_NOT_CONTAIN]: ERROR_CODE_MUST_NOT_CONTAIN_DESCRIPTION,
  [ERROR_CODE_PROHIBIT_LETTERS]: ERROR_CODE_PROHIBIT_LETTERS_DESCRIPTION,
  [ERROR_CODE_PROHIBIT_NUMBERS]: ERROR_CODE_PROHIBIT_NUMBERS_DESCRIPTION,
  [ERROR_CODE_PROHIBIT_WHITESPACE]: ERROR_CODE_PROHIBIT_WHITESPACE_DESCRIPTION,
  [ERROR_CODE_PROHIBIT_SYMBOLS]: ERROR_CODE_PROHIBIT_SYMBOLS_DESCRIPTION,
  [ERROR_CODE_INVALID_DATE]: ERROR_CODE_INVALID_DATE_DESCRIPTION,
  [ERROR_CODE_INVALID_URL]: ERROR_CODE_INVALID_URL_DESCRIPTION,
  [ERROR_CODE_INVALID_URL_DOMAIN]: ERROR_CODE_INVALID_URL_DOMAIN_DESCRIPTION,
  [ERROR_CODE_INVALID_LIST_VALUE]: ERROR_CODE_INVALID_LIST_VALUE_DESCRIPTION,
  [ERROR_CODE_MISSING_LIST_GOVERNANCE]: ERROR_CODE_MISSING_LIST_GOVERNANCE_DESCRIPTION,
  [ERROR_CODE_MISSING_LIST]: ERROR_CODE_MISSING_LIST_DESCRIPTION,
  [WARNING_CODE_FLAG_NEW]: WARNING_CODE_FLAG_NEW_DESCRIPTION,
} as const
